module.exports = "<div class=\"gmao-center hide-xs hide-sm\">\r\n    <div>\r\n        <span ng-if=\"$ctrl.applicationInfo.app.profiles != 'prod' && $ctrl.applicationInfo.app.profiles !='aws'\">{{$ctrl.applicationInfo.app.profiles}}</span>\r\n    </div>\r\n    <div>\r\n        <span>{{$ctrl.applicationInfo.app.version.type}} </span>\r\n    </div>\r\n    <div>\r\n        <span>{{$ctrl.applicationInfo.app.version.number}}</span>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/util/component/gmao-application-info.html
// module id = 287
// module chunks = 1